import { Injectable } from '@angular/core';
import { HttpChatProvider } from '../providers/http-chat';

/**
 * Generated class for the FamilyPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Injectable()
export class ChatAction {

  constructor(
		private httpChatProvider:HttpChatProvider,
  	) {
  }

  /**
   * 登録処理（新規・更新含む）
   */
  save(data:{room_id:any, room_type:any, message:any}){

    //記入者
    data["type"] = "text";

    return this.httpChatProvider.save(data);
  }

  /**
   * 写真登録処理（新規・更新含む）
   */
  savePicture(data:{room_id:any, room_type:any, imageData:any}){

    //記入者
    data["type"] = "picture";

    return this.httpChatProvider.save(data);
  }

  /**
   * 一覧取得
   */
  getList(room_id){

    return this.httpChatProvider.getList(room_id);
  }

  /**
   * チャット削除
   */
  removeChat(chatId){

    return this.httpChatProvider.removeChat(chatId);
  }
}


// WEBPACK FOOTER //
// ./src/actions/chat.action.ts